import Filelist from '@/components/common/fileupload/filelist/Filelist.vue'
import ClientContractAgreementEdit from '@/components/client/contract/agreement/edit/ClientContractAgreementEdit.vue'
import { mapState } from 'vuex';

export default {
  name: 'ClientContractListExpand',
  props: {
    data: Object,
    info: Object
  },
  components: {
    Filelist,
    ClientContractAgreementEdit
  },
  data () {
    return {
      loading: false,
      loadingDrns: [],
      manualBillType: null,
      manualBillYear: null,
      manualBillYearError: false
    }
  },
  computed: {
    ...mapState(['config']),
    drnDocuments () {
      return this.ZPFormatHelper.getDrnReportOptions(this.data);
    },
    tableHeaders () {
      const headers = [
        { key: 'contractNumber', label: this.$t('contractAgreement.contractNumber') },
        { key: 'from_date_period_id', label: this.$t('general.filters.date-period-from'), format: 'formatDatePeriod' },
        { key: 'to_date_period_id', label: this.$t('general.filters.date-period-to'), format: 'formatDatePeriod' },
        { key: 'notifyEnding', label: this.$t('contractAgreement.notifyEnding'), format: 'formatYesNo' },
        { key: 'files', label: this.$t('general.file.files'), format: 'filelist', fileReqPath: 'client/files/download/contract-agreement' }
      ];
      if (this.canEdit) {
        headers.push({ key: 'actions', label: '', actions: [{ label: this.$t('menu.contractAgreement.edit'), emit: 'editItem', icon: 'edit', bicon: 'pencil-fill' }] })
      }
      return headers;
    },
    filterActions () {
      const actions = { extra: [] };
      if (this.canEdit) {
        if (this.isPackageContract) {
          actions.extra.push({
            title: this.$t('menu.entranceBill.new'),
            class: 'btn-warning text-dark font-weight-bold',
            event: 'addBill',
            icon: 'plus'
          });
        }
        if (this.isAuthorizationContract) {
          actions.extra.push({
            title: this.$t('menu.authorizationBill.new'),
            class: 'btn-warning text-dark font-weight-bold',
            event: 'addAuthorizationBill',
            icon: 'plus'
          });
        }
        if (this.isElectronicsContract) {
          actions.extra.push({
            title: this.$t('menu.eeeDataFeeBill.new'),
            class: 'btn-warning text-dark font-weight-bold' + (this.hasAuthorizationContract ? '' : ' btn-disabled'),
            event: 'addEeeDataFeeBill',
            icon: 'plus'
          });
        }
        if (this.isHarmfulGoodsContract) {
          actions.extra.push({
            title: this.$t('menu.batteryDataFeeBill.new'),
            class: 'btn-warning text-dark font-weight-bold' + (this.hasAuthorizationContract ? '' : ' btn-disabled'),
            event: 'addBatteryDataFeeBill',
            icon: 'plus'
          });
        }
        actions.add = { title: this.$t('menu.contractAgreement.new') };
      }
      return actions;
    },
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-clients');
    },
    isPackageContract () {
      return this.$store.getters.getParamFromConfig('material_groups', this.data.material_group_id, 'code') === 'PACKAGE';
    },
    isAuthorizationContract () {
      return this.$store.getters.getParamFromConfig('material_groups', this.data.material_group_id, 'code') === 'AUTH';
    },
    isElectronicsContract () {
      return this.$store.getters.getParamFromConfig('material_groups', this.data.material_group_id, 'code') === 'ELECTRO';
    },
    isHarmfulGoodsContract () {
      return this.$store.getters.getParamFromConfig('material_groups', this.data.material_group_id, 'code') === 'VKP';
    },
    clientContracts () {
      if (this.info.contracts) {
        return this.info.contracts;
      }
      return [this.data];
    },
    hasAuthorizationContract () {
      return this.clientContracts.some(contract => {
        return this.$store.getters.getParamFromConfig('material_groups', contract.material_group_id, 'code') === 'AUTH';
      });
    },
    authorizationContract () {
      return this.clientContracts.find(contract => {
        return this.$store.getters.getParamFromConfig('material_groups', contract.material_group_id, 'code') === 'AUTH';
      });
    },
    tableExpandConfig () {
      return { component: 'ClientContractListExpand', info: { clientApiId: this.info.clientApiId, itemname: 'contract-agreement' } };
    },
    yearOptions () {
      const perConfig = this.config ? this.config.datePeriodConfig : null;
      const options = [];
      if (perConfig) {
        const contract = this.shouldUseAuthorizationContractYear ? this.authorizationContract : this.data;
        const startYear = contract && contract.from_date_period_id ? parseInt((contract.from_date_period_id + '').substr(0, 4)) : perConfig.startYear;
        for (let year = perConfig.endYear; year >= startYear; year--) {
          options.push({ value: year, text: year });
        }
      }
      return options;
    },
    yearOptionsWithEmpty () {
      return [{ value: null, text: '' }, ...this.yearOptions];
    },
    manualBillConfig () {
      const configs = {
        'authorization-bill': {
          title: this.$t('menu.authorizationBill.createTitle'),
          intro: this.$t('menu.authorizationBill.yearIntro')
        },
        'authorization-entrance-bill': {
          title: this.$t('menu.eeeDataFeeBill.createTitle'),
          intro: this.$t('menu.eeeDataFeeBill.yearIntro')
        },
        'electrical-register-bill': {
          title: this.$t('menu.batteryDataFeeBill.createTitle'),
          intro: this.$t('menu.batteryDataFeeBill.yearIntro')
        }
      };
      return configs[this.manualBillType] ?? {};
    },
    shouldUseAuthorizationContractYear () {
      return ['authorization-entrance-bill', 'electrical-register-bill'].includes(this.manualBillType);
    },
    manualBillModalTitle () {
      return this.manualBillConfig.title ?? '';
    },
    manualBillModalIntro () {
      return this.manualBillConfig.intro ?? '';
    },
    manualBillPeriodInfo () {
      return this.$t('menu.manualBill.periodInfo', { year: this.manualBillYear });
    },
    createBillLabel () {
      return this.$t('menu.manualBill.createBill');
    }
  },
  methods: {
    editItem (el) {
      this.$refs.editElFrm.show(el);
    },
    addBill () {
      this.createBill('entrance-bill');
    },
    addAuthorizationBill () {
      this.openManualBillYearModal('authorization-bill');
    },
    addEeeDataFeeBill () {
      if (!this.hasAuthorizationContract) {
        return;
      }
      this.openManualBillYearModal('authorization-entrance-bill');
    },
    addBatteryDataFeeBill () {
      if (!this.hasAuthorizationContract) {
        return;
      }
      this.openManualBillYearModal('electrical-register-bill');
    },
    openManualBillYearModal (billType) {
      this.manualBillType = billType;
      this.manualBillYear = null;
      this.manualBillYearError = false;
      this.$refs['manual-bill-year-modal'].show();
    },
    closeManualBillYearModal () {
      this.$refs['manual-bill-year-modal'].hide();
    },
    createSelectedYearBill () {
      this.manualBillYearError = !this.manualBillYear;
      if (this.manualBillYearError) {
        return;
      }
      this.createBill(this.manualBillType, this.manualBillYear);
    },
    createBill (billType, year = null) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      const self = this;
      this.ApiRequest.request('client/single/' + this.info.clientApiId + '/contract/' + this.data.id + '/' + billType, this.ApiRequest.REQUEST_POST, { year: year }, function (response) {
        self.loading = false;
        if (response.errors || response.error) {
          self.ApiRequest.displayErrorDialog(response, self);
        } else {
          self.closeManualBillYearModal();
          self.$emit('saved', response);
          self.$router
            .push({ name: 'menu.client.edit', params: { clientApiId: self.info.clientApiId }, hash: '#bills' })
            .catch(error => {
              if (error && error.name !== 'NavigationDuplicated') {
                throw error;
              }
              const editRoute = { name: 'menu.client.edit', params: { clientApiId: self.info.clientApiId } };
              self.$router.replace(editRoute).then(() => {
                self.$router.push({ ...editRoute, hash: '#bills' });
              });
            });
        }
      });
    },
    getDrnPdf (pdfCode) {
      this.loadingDrns.push(pdfCode);
      const self = this;
      this.ApiRequest.request('client/single/' + this.info.clientApiId + '/contract/' + this.data.id + '/drn-pdf/' + pdfCode, this.ApiRequest.REQUEST_DOWNLOAD, {}, function (response) {
        const idx = self.loadingDrns.indexOf(pdfCode);
        if (idx >= 0) {
          self.loadingDrns.splice(idx, 1);
        }
      });
    }
  }
}
